import { AxiosError } from "axios";

import { buildPaginationQuery } from "@/helpers/request-helpers";
import { ICustomerTemplate } from "@/interfaces/customer-template.interface";
import { apiT2B } from "@/lib/axios";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

const baseUrl = "/api/v1/CustomerTemplate";

export function normalizeCustomerTemplate(raw: Record<string, unknown>): ICustomerTemplate | null {
  const idRaw = raw.id ?? raw.Id;
  const id = typeof idRaw === "number" ? idRaw : Number(idRaw);

  if (!Number.isFinite(id)) return null;

  const platformIdRaw = raw.platformId ?? raw.PlatformId;
  const sourceIdRaw = raw.sourceId ?? raw.SourceId;
  const deletedDate = raw.deletedDate ?? raw.DeletedDate;

  return {
    id,
    platformId: platformIdRaw === null || platformIdRaw === undefined ? null : Number(platformIdRaw),
    platformName: String(raw.platformName ?? raw.PlatformName ?? ""),
    name: String(raw.name ?? raw.Name ?? ""),
    type: String(raw.type ?? raw.Type ?? "").trim(),
    status: String(raw.status ?? raw.Status ?? "").trim(),
    sourceId: sourceIdRaw === null || sourceIdRaw === undefined ? null : Number(sourceIdRaw),
    externalId: String(raw.externalId ?? raw.ExternalId ?? ""),
    text: String(raw.text ?? raw.Text ?? ""),
    messageTemplate: String(raw.messageTemplate ?? raw.MessageTemplate ?? ""),
    rowDate: String(raw.rowDate ?? raw.RowDate ?? ""),
    deletedDate: deletedDate ? String(deletedDate) : null,
    notificationOn: raw.notificationOn === false || raw.NotificationOn === false ? false : true,
  };
}

export async function filterCustomerTemplates(
  filter: IFilter<ICustomerTemplate>[],
  pagination: RequestPagination
): Promise<PaginatedResponse<ICustomerTemplate>> {
  try {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await apiT2B.post(`${baseUrl}/filter?${paginationQuery}`, { filter });

    const data = response.data as Record<string, unknown> & {
      items?: Record<string, unknown>[];
      Items?: Record<string, unknown>[];
    };

    const rawItems = data.items ?? data.Items ?? [];
    const items = rawItems
      .map((item) => normalizeCustomerTemplate(item as Record<string, unknown>))
      .filter((item): item is ICustomerTemplate => item !== null);

    return {
      items,
      totalCount: Number(data.totalCount ?? data.TotalCount ?? items.length),
      pageNumber: Number(data.pageNumber ?? data.PageNumber ?? pagination.pageNumber),
      pageSize: Number(data.pageSize ?? data.PageSize ?? pagination.pageSize),
      hasNextPage: Boolean(data.hasNextPage ?? data.HasNextPage ?? false),
      hasPreviousPage: Boolean(data.hasPreviousPage ?? data.HasPreviousPage ?? false),
    };
  } catch (error) {
    if (error instanceof AxiosError) {
      throw new Error(error.response?.data?.message || "Falha ao carregar os templates");
    }

    throw new Error("Falha ao carregar os templates");
  }
}
